import { IFilters } from '../types';

const initialValues: IFilters = {
  name: '',
};

export default initialValues;
